var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrev(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 10.4999H10.207L12.646 8.06088C12.9274 7.77962 13.0855 7.39809 13.0856 7.00024C13.0857 6.60238 12.9277 6.22078 12.6465 5.93938C12.3652 5.65799 11.9837 5.49985 11.5858 5.49976C11.188 5.49966 10.8064 5.65762 10.525 5.93888L6.93896 9.52488C6.28373 10.1819 5.91577 11.072 5.91577 11.9999C5.91577 12.9278 6.28373 13.8178 6.93896 14.4749L10.525 18.0609C10.8064 18.3421 11.188 18.5001 11.5858 18.5C11.9837 18.4999 12.3652 18.3418 12.6465 18.0604C12.9277 17.779 13.0857 17.3974 13.0856 16.9995C13.0855 16.6017 12.9274 16.2201 12.646 15.9389L10.207 13.4999H19C19.3978 13.4999 19.7793 13.3418 20.0606 13.0605C20.3419 12.7792 20.5 12.3977 20.5 11.9999C20.5 11.6021 20.3419 11.2205 20.0606 10.9392C19.7793 10.6579 19.3978 10.4999 19 10.4999Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrev);
export default __webpack_public_path__ + "static/media/prev.64051ff4939ffe714e17c271a922d143.svg";
export { ForwardRef as ReactComponent };